/**
 * IMPORTS
 */

/**
 * Função que valida o content type e retorna a extensão
 * @param contentType
 * @returns
 */
const validateToContentTypeExtensao = (contentType?: string): string | null => {
  if (!contentType) return null;

  const formattedContentType = contentType.toLowerCase();

  if (formattedContentType.includes("text/csv")) return "csv";
  if (formattedContentType.includes("text/plain")) return "txt";
  if (formattedContentType.includes("application/vnd.ms-excel")) return "xls";
  if (formattedContentType.includes("spreadsheetml.sheet")) return "xlsx";

  return null;
};

/**
 * Função que extrai o nome do arquivo do Content-Disposition
 * @param header
 * @returns
 */
const extrairNomeArquivoDoContentDisposition = (header?: string): string | null => {
  if (!header) return null;

  const filenameStarMatch = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (filenameStarMatch?.[1]) {
    return decodeURIComponent(filenameStarMatch[1]).replace(/["']/g, "");
  }

  const filenameMatch = header.match(/filename="?([^"]+)"?/i);
  if (filenameMatch?.[1]) {
    return filenameMatch[1].trim().replace(/["']/g, "");
  }

  return null;
};

/**
 * Função que monta o nome do arquivo fallback
 * @param planilhaNome
 * @param remessaId
 * @param contentType
 * @returns
 */
const montarNomeArquivoFallback = (
  planilhaNome: string,
  remessaId: number,
  contentType?: string
): string => {
  const hoje = new Date().toLocaleDateString("pt-BR").replace(/\//g, "-");
  const base = planilhaNome ? `${planilhaNome}-${hoje}` : `remessa_${remessaId}_arquivo_${hoje}`;
  const extensao = validateToContentTypeExtensao(contentType);

  if (!extensao) {
    return `${base}.xlsx`;
  }

  return `${base}.${extensao}`;
};

export {
  extrairNomeArquivoDoContentDisposition,
  montarNomeArquivoFallback,
  validateToContentTypeExtensao,
};
